"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Actions = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "AlertBanner";
exports.classes = {
    sticky: `${PREFIX}-sticky`,
    success: `${PREFIX}-success`,
    error: `${PREFIX}-error`,
    icon: `${PREFIX}-icon`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    padding: "8px 0",
    fontSize: "1rem",
    [`&.${exports.classes.sticky}`]: {
        position: "sticky"
    },
    [`&.${exports.classes.success}`]: {
        border: `4px solid ${theme.colours.success400}`,
        [`& .${exports.classes.icon}`]: {
            color: theme.colours.success400
        }
    },
    [`&.${exports.classes.error}`]: {
        border: `4px solid ${theme.colours.error400}`,
        [`& .${exports.classes.icon}`]: {
            color: theme.colours.error400
        }
    }
}));
exports.Actions = (0, styles_1.styled)("div")({
    color: "inherit",
    position: "absolute",
    top: "8px",
    right: "8px"
});
exports.Title = (0, styles_1.styled)(typography_1.default)({
    display: "flex",
    alignContent: "center",
    margin: "20px 0 24px",
    [`& .${exports.classes.icon}`]: {
        width: "24px",
        height: "24px",
        marginRight: "12px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FsZXJ0LWJhbm5lci9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLCtEQUF1QztBQUV2QyxNQUFNLE1BQU0sR0FBRyxhQUFhLENBQUM7QUFFaEIsUUFBQSxPQUFPLEdBQUc7SUFDckIsTUFBTSxFQUFFLEdBQUcsTUFBTSxTQUFTO0lBQzFCLE9BQU8sRUFBRSxHQUFHLE1BQU0sVUFBVTtJQUM1QixLQUFLLEVBQUUsR0FBRyxNQUFNLFFBQVE7SUFDeEIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsUUFBUSxFQUFFLFVBQVU7SUFDcEIsT0FBTyxFQUFFLE9BQU87SUFDaEIsUUFBUSxFQUFFLE1BQU07SUFDaEIsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZCLFFBQVEsRUFBRSxRQUFRO0tBQ25CO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1FBQ3hCLE1BQU0sRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsVUFBVSxFQUFFO1FBQy9DLENBQUMsTUFBTSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUN0QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxVQUFVO1NBQ2hDO0tBQ0Y7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdEIsTUFBTSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRLEVBQUU7UUFDN0MsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1lBQ3RCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVE7U0FDOUI7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDbkMsS0FBSyxFQUFFLFNBQVM7SUFDaEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsR0FBRyxFQUFFLEtBQUs7SUFDVixLQUFLLEVBQUUsS0FBSztDQUNiLENBQUMsQ0FBQztBQUVVLFFBQUEsS0FBSyxHQUFHLElBQUEsZUFBTSxFQUFDLG9CQUFVLENBQUMsQ0FBQztJQUN0QyxPQUFPLEVBQUUsTUFBTTtJQUNmLFlBQVksRUFBRSxRQUFRO0lBQ3RCLE1BQU0sRUFBRSxhQUFhO0lBQ3JCLENBQUMsTUFBTSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUN0QixLQUFLLEVBQUUsTUFBTTtRQUNiLE1BQU0sRUFBRSxNQUFNO1FBQ2QsV0FBVyxFQUFFLE1BQU07S0FDcEI7Q0FDRixDQUFDLENBQUMifQ==